export enum RoleResponse {
  Admin = 'admin',
  Vendor = 'vendor',
  EndUser = 'enduser'
}
